export const WEEK_ORDER = {
  THIS_WEEK: '今週',
  NEXT_WEEK: '来週',
  NEXT_NEXT_WEEK: '再来週'
};
